<template>
  <section class="featured-protocol">
    <div class="protocol">
        <h2><router-link :to="{ name: 'protocol', params: {slug: protocol._source.slug }}">{{ protocol._source.title }}</router-link></h2>
        <div id="time" v-if="info('time-estimate')">{{ info('time-estimate') }}</div>
        <p id="author">Author: {{protocol._source.author}}
        <span v-if="hasContent('partner')" id="partner"> | Partner: {{protocol._source.partner}}</span></p>
        <p id="preview" v-html="makeHtml(protocol._source.markdown.preview)"></p>

    </div>
  </section>
</template>

<script>
  import showdown from 'showdown'
  export default {
    name: 'FeaturedProtocol',
    props: ['protocol'],
    methods: {
      makeHtml (markdownText) {
        return new showdown.Converter().makeHtml(markdownText)
      },
      info (key) {
        return this.protocol._source[key]
      },
      hasContent (key) {
        return this.protocol._source[key] !== ''
      }
    }
  }
</script>



// WEBPACK FOOTER //
// FeaturedProtocol.vue?347bba63